import { ReactElement, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NotFoundLogo from './not-found-icon.svg';
import styles from './errorpage.module.scss';
import { reportError } from '../../analytics';

export interface ErrorPageProps {
  status: string | number;
  message: string;
  children?: ReactElement | ReactElement[] | string;
}

export default function ErrorPage({
  status,
  message,
  children = null,
}: ErrorPageProps) {
  useEffect(() => {
    reportError(message, 1500);
    document.title = 'Page not found | PMI Partner Platform';
  }, []);

  return (
    <Container className="p-xxl-5 py-3 px-2 mx-auto max-xl-container">
      <Row>
        <Col className={styles.container}>
          <h1 className="mb-3">
            {status} : {message}
          </h1>
          <img
            className="mb-4"
            height={150}
            width={150}
            src={NotFoundLogo}
            alt="Question mark sign"
          />
          {children}
        </Col>
      </Row>
    </Container>
  );
}
